'use client'

import { useRouter } from 'next/navigation'
import { isAuthenticatedViaMiddlewareCookie } from '@/lib/isAuthenticatedViaMiddlewareCookie'
import { useGetProfileQuery } from '@/lib/store/api/userApi'
import { useEffect, useState } from 'react'

export default function BlockedPatientGuard() {
    const router = useRouter()
    // null during SSR and the first client render so we match HTML and defer profile fetch until after mount.
    const [authCookieIndicatesLogin, setAuthCookieIndicatesLogin] = useState<boolean | null>(null)

    useEffect(() => {
        setAuthCookieIndicatesLogin(isAuthenticatedViaMiddlewareCookie())
    }, [])

    const skipGetProfile = authCookieIndicatesLogin !== true

    const { data: user } = useGetProfileQuery(undefined, { skip: skipGetProfile })

    useEffect(() => {
        if (user?.blocked === true) {
            router.replace('/account')
        }
    }, [user?.blocked, router])

    return null
}
